import { NgModule } from '@angular/core';
import { ListingCardComponent } from './listing-card.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PropertyDetailsModule } from '../property-details/property-details.module';
import { SharedDirectivesModule } from '../../directives/shared-directives.module';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ListingPriceArrowModule } from '../listing-price-arrow/listing-price-arrow.module';
import { ListingAddressModule } from '../address/listing-address.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ListingTagsContainerComponent } from './listing-tags-container/listing-tags-container.component';
import { ListingTagComponent } from './listing-tag/listing-tag.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    RouterModule.forChild([]),
    PropertyDetailsModule,
    ListingPriceArrowModule,
    ListingAddressModule,
    SharedDirectivesModule,
    SharedPipesModule,
    LazyLoadImageModule
  ],
  declarations: [
    ListingCardComponent,
    ListingTagsContainerComponent,
    ListingTagComponent
  ],
  exports: [
    ListingCardComponent
  ]
})
export class ListingCardModule { }
